import {User} from '@hconnect/apiclient'
import {useMutation} from '@tanstack/react-query'
import {AxiosError} from 'axios'
import {useDispatch} from 'react-redux'

import {api} from '../../App.store'
import {fetchLoggedInUserProfile} from '../../modules/LoggedInUser.actions'

type UpdateUserProps = {
  userId: string
  userProp: Partial<User>
}
const updateUser = async ({userId, userProp}: UpdateUserProps) => {
  const response = await api.put<User>(`/users/${userId}`, userProp)
  return response.data
}

export const useUpdateUserData = () => {
  const dispatch = useDispatch()

  return useMutation<User, AxiosError, UpdateUserProps>(updateUser, {
    onSuccess: (data) => {
      dispatch(fetchLoggedInUserProfile(data.user_id))
    }
  })
}
